import { useCookies } from '@vueuse/integrations/useCookies';

const AUTH_TOKEN_COOKIE_NAME = 'tradier_auth_token.local';

export default class CookieService {
  cookieNames = null;
  cookieOptions = null;
  _cookies = null;

  constructor(cookieNames, cookieOptions) {
    this.cookieNames = cookieNames;
    this.cookieOptions = cookieOptions;

    this._cookies = useCookies([], this.cookieOptions);
  }

  setJwtToCookie(jwt, expiry) {
    this._cookies.set(this.cookieNames.JWT_COOKIE_NAME, jwt, { ...this.cookieOptions, maxAge: expiry });
  }

  getJwtFromCookie() {
    return this._cookies.get(this.cookieNames.JWT_COOKIE_NAME);
  }

  clearJwtFromCookie() {
    return this._cookies.remove(this.cookieNames.JWT_COOKIE_NAME, this.cookieOptions);
  }

  setRedirectToCookie(redirect) {
    this._cookies.set(this.cookieNames.REDIRECT_COOKIE_NAME, redirect, this.cookieOptions);
  }

  getRedirectFromCookie() {
    return this._cookies.get(this.cookieNames.REDIRECT_COOKIE_NAME);
  }

  setStateToCookie(state) {
    this._cookies.set(this.cookieNames.STATE_COOKIE_NAME, state, this.cookieOptions);
  }

  getStateFromCookie() {
    return this._cookies.get(this.cookieNames.STATE_COOKIE_NAME);
  }

  clearStateCookie() {
    this._cookies.remove(this.cookieNames.STATE_COOKIE_NAME, this.cookieOptions);
  }

  clearRedirectCookie() {
    this._cookies.remove(this.cookieNames.REDIRECT_COOKIE_NAME, this.cookieOptions);
  }

  getOnboardingParamsFromCookie() {
    return this._cookies.get(this.cookieNames.ONBOARDING_PARAMS_COOKIE_NAME);
  }

  clearOnboardingParamsFromCookie() {
    return this._cookies.remove(this.cookieNames.ONBOARDING_PARAMS_COOKIE_NAME, {
      path: '/',
      domain: ['production', 'staging'].includes(import.meta.env.MODE) ? '.tradier.com' : 'localhost',
      sameSite: 'strict',
      secure: true,
    });
  }

  clearAuthCookie() {
    return this._cookies.remove(AUTH_TOKEN_COOKIE_NAME, { domain: '.tradier.com', sameSite: true, secure: true });
  }

  setEnvironmentToCookie(environment) {
    this._cookies.set(this.cookieNames.ENVIRONMENT_COOKIE_NAME, environment, this.cookieOptions);
  }
  getEnvironmentFromCookie() {
    return this._cookies.get(this.cookieNames.ENVIRONMENT_COOKIE_NAME);
  }
  clearEnvironmentCookie() {
    return this._cookies.remove(this.cookieNames.ENVIRONMENT_COOKIE_NAME, this.cookieOptions);
  }
  setAccountToCookie(account) {
    this._cookies.set(this.cookieNames.ACCOUNT_COOKIE_NAME, account, this.cookieOptions);
  }
  getAccountFromCookie() {
    return this._cookies.get(this.cookieNames.ACCOUNT_COOKIE_NAME);
  }
  clearAccountCookie() {
    return this._cookies.remove(this.cookieNames.ACCOUNT_COOKIE_NAME, this.cookieOptions);
  }
  setAccessTokenToCookie(accessToken) {
    this._cookies.set(this.cookieNames.ACCESS_TOKEN_COOKIE_NAME, accessToken, this.cookieOptions);
  }
  getAccessTokenFromCookie() {
    return this._cookies.get(this.cookieNames.ACCESS_TOKEN_COOKIE_NAME);
  }
  clearAccessTokenCookie() {
    return this._cookies.remove(this.cookieNames.ACCESS_TOKEN_COOKIE_NAME, this.cookieOptions);
  }
}
